import { fireLinkTag } from './tagManager';

function tagProductTitleClick() {
  const eventName = 'brand click';

  fireLinkTag({ event_name: eventName, link_name: eventName });
}

export default tagProductTitleClick;
